module.exports = __webpack_public_path__ + "img/male.d195cf37.svg";